import { render, staticRenderFns } from "./client-setup-main.vue?vue&type=template&id=689735bf&scoped=true&"
import script from "./client-setup-main.vue?vue&type=script&lang=ts&"
export * from "./client-setup-main.vue?vue&type=script&lang=ts&"
import style0 from "./client-setup-main.vue?vue&type=style&index=0&id=689735bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689735bf",
  null
  
)

export default component.exports